var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from "../../../api/API";
import { EditContext } from "../../../misc/scroller/EditProvider";
import { useContext } from "react";
import { FrameBuilder } from "../../manufacturing/FrameBuilder";
import { jsx as _jsx } from "react/jsx-runtime";
export function CreateStockingFrameProduct(props) { const edit = useContext(EditContext); return /*#__PURE__*/ _jsx(FrameBuilder, { onCancel: props.onDone, components: true, onDone: (p) => __awaiter(this, void 0, void 0, function* () { p.isStocking = true; yield api.products.upsert(p); edit.reload(); props.onDone(); }) }); }
